// assets/color-swatch-map.js
//
// Plain color-name (word or phrase) -> hex lookup, read by
// assets/color-swatches.js to paint swatches for the "Color" product
// option without relying on Shopify's native swatch metaobject data.
//
// Keys are lowercase and single-space-normalized (collapse repeated
// whitespace, no leading/trailing space) -- assets/color-swatches.js
// normalizes each color name the same way before looking it up here, so
// keys must match that normalization exactly.
//
// Multi-word phrase keys (e.g. "heather grey") sit alongside their
// component single words (e.g. "heather", "grey") in this same object --
// the matching logic in assets/color-swatches.js always tries the
// longest phrase first, so a phrase entry naturally takes priority over
// its component words without needing a separate data structure.
//
// Seeded from a real analysis of 906 distinct "Color" option values
// already live in the Truwear Locker catalog (see
// docs/superpowers/specs/2026-09-30-color-swatches-design.md). Extend
// this file directly as new unrecognized color names are noticed --
// nothing else needs to change to add an entry.
window.ColorSwatchMap = {
  // Neutrals
  white: '#FFFFFF',
  black: '#000000',
  grey: '#808080',
  gray: '#808080',
  charcoal: '#36454F',
  silver: '#C0C0C0',
  ash: '#B2BEB5',
  bone: '#E3DAC9',
  cream: '#FFFDD0',
  natural: '#F5F5DC',
  khaki: '#C3B091',
  storm: '#71797E',
  anthracite: '#293133',
  asphalt: '#333333',
  birch: '#DED1B6',

  // Blues
  blue: '#0072CE',
  navy: '#000080',
  royal: '#4169E1',
  teal: '#008080',
  aqua: '#00FFFF',
  columbia: '#C4D8E2',
  atlantic: '#1C6EA4',

  // Greens
  green: '#008000',
  forest: '#228B22',
  kelly: '#4CBB17',
  lime: '#32CD32',
  mint: '#98FF98',
  olive: '#808000',

  // Reds / pinks / purples
  red: '#FF0000',
  cardinal: '#C41E3A',
  maroon: '#800000',
  burgundy: '#800020',
  pink: '#FFC0CB',
  fuchsia: '#FF00FF',
  purple: '#800080',
  azalea: '#F76FDA',

  // Yellows / oranges / browns
  yellow: '#FFFF00',
  gold: '#FFD700',
  orange: '#FFA500',
  brown: '#964B00',
  chocolate: '#7B3F00',
  amber: '#FFBF00',

  // Other / approximated
  clear: '#F2F2F2',
  camo: '#78866B',

  // Two-word (and longer) phrases -- checked before their component
  // single words by assets/color-swatches.js's longest-phrase-first scan.
  'heather grey': '#B2BEB5',
  'heather gray': '#B2BEB5',
  'athletic heather': '#9EA1A3',
  'light blue': '#ADD8E6',
  'lt blue': '#ADD8E6',
  'dark blue': '#00008B',
  'true blue': '#0073CF',
  'royal blue': '#4169E1',
  'bright royal': '#0F52BA',
  'aegean blue': '#3A6B8A',
  'arctic blue': '#6CB4EE',
  'light grey': '#D3D3D3',
  'light gray': '#D3D3D3',
  'dark grey': '#4A4A4A',
  'dark gray': '#4A4A4A',
  'gunmetal': '#2A3439',
  'dark green': '#006400',
  'forest green': '#228B22',
  'kelly green': '#4CBB17',
  'irish green': '#009A44',
  'athletic gold': '#D4AF37',
  'antique gold': '#C08A3E',
  'amber gold': '#C9A227',
  'metallic gold': '#D4AF37',
  'metallic silver': '#AAA9AD',
  'metallic black': '#3B3C36',
  'antique orange': '#C46210',
  'dark orange': '#D2691E',
  'neon yellow': '#DFFF00',
  'neon green': '#39FF14',
  'neon pink': '#FF6EC7',
  'neon orange': '#FF5F1F',
  'electric blue': '#7DF9FF',
  'deep purple': '#36013F',
  'antique cherry red': '#971B2F',
  'antique sapphire': '#0067A5',
  'antique jade dome': '#00A86B',
  'antique irish green': '#00843D',
  'athletic maroon': '#7B1E3A',
  'athletic kelly': '#4CBB17',
  'vegas gold': '#C5B358',
  'mink beige': '#CABFAE',

  // 2026-09-30 expansion -- added after a full-catalog coverage audit
  // against Truwear Locker (see conversation/session notes) found ~31%
  // of distinct Color values fully or partially unresolved, concentrated
  // in apparel-brand colorway names (Bella+Canvas/Next Level style, e.g.
  // "Graphite", "Ecru", "Stone", "Mauve") that the original promo-product
  // seed never covered. These are single words/short phrases so the
  // longest-phrase-first matching in assets/color-swatches.js applies
  // them to any longer name containing them (e.g. "Graphite Heather",
  // "Light Oxford", "Deep Smoke") without a separate entry per variant.
  graphite: '#53565A',
  stone: '#8D8579',
  heather: '#B2BEB5',
  loden: '#4A5D23',
  ecru: '#C2B280',
  marshmallow: '#F3EEE0',
  magnet: '#565656',
  tan: '#D2B48C',
  oxford: '#63666A',
  blacktop: '#2B2B2B',
  hunter: '#355E3B',
  walnut: '#5C4033',
  smoke: '#73787C',
  army: '#4B5320',
  coal: '#3C3C3C',
  shadow: '#4A4E54',
  oatmeal: '#C8B99C',
  midnight: '#191970',
  caramel: '#C68958',
  chrome: '#C9CBCC',
  scarlet: '#FF2400',
  hthr: '#B2BEB5', // "heather" abbreviation seen in some vendor color names (e.g. "Prem Hthr")
  liberty: '#2C3E67',
  ivory: '#FFFFF0',
  turquoise: '#40E0D0',
  indigo: '#3E5C76',
  cinder: '#45413C',
  camel: '#C19A6B',
  plum: '#8E4585',
  sage: '#9CAF88',
  gravel: '#7C7C74',
  sandstone: '#C2A878',
  coffee: '#6F4E37',
  reflective: '#D9D9D9',
  'heavy metal': '#43413C',
  parchment: '#F1E9D2',
  maritime: '#1B3A4B',
  clay: '#B66A50',
  cypress: '#4B6043',
  eucalyptus: '#8FA98F',
  moss: '#8A9A5B',
  sunset: '#FD5E53',
  denim: '#4A6FA5',
  lilac: '#C8A2C8',
  lavender: '#E6E6FA',
  coral: '#FF7F50',
  biscuit: '#DEB887',
  aluminum: '#A9ACB6',
  slate: '#708090',
  port: '#630930',
  sahara: '#D9B382',
  buck: '#8B6F47',
  copper: '#B87333',
  mustard: '#E1AD01',
  volt: '#CEFF00',
  mauve: '#B784A7',
  autumn: '#A0522D',
  berry: '#8E3B46',
  bubblegum: '#FFC1CC',
  butter: '#FFEA70',
  charlotte: '#4C9A8D',
  chestnut: '#954535',
  citrus: '#FFA420',
  cobalt: '#0047AB',
  cocoa: '#6B4423',
  fire: '#FF4500',
  granite: '#6E6E6E',
  jade: '#00A86B',
  kiwi: '#8EE53F',
  lemon: '#FFF44F',
  mushroom: '#BDB0A0',
  orchid: '#DA70D6',
  pistachio: '#93C572',
  powder: '#B0E0E6',
  safari: '#B08D57',
  sand: '#C2B280',
  seafoam: '#93E9BE',
  emerald: '#50C878',
  lagoon: '#2E8B99',
  ocean: '#1B6B93',
  violet: '#8A2BE2',
  watermelon: '#FC6C85',
  rose: '#C08497',
  magentawhite: '#FF00FF', // run-on two-tone name with no separator -- resolves to its magenta half
  magenta: '#FF00FF',
  sapphire: '#0F52BA',
  quarry: '#8B8878',
  grape: '#6F2DA8',
  taupe: '#483C32',
  canvas: '#D2C29D',
  pebble: '#B7B09C',
  hibiscus: '#E4287C',
  steel: '#6F8FAF',
  mocha: '#7B5343',
  adriatic: '#2E5E6E',
  driftwood: '#AFA593',
  raspberry: '#E30B5C',
  merlot: '#730039',
  radish: '#C62D42',
  aquamarine: '#7FFFD4',
  fawn: '#E5AA70',
  tarmac: '#3A3B3C',
  desert: '#C8A165',
  envy: '#009B77',
  oat: '#DDD2A6',
  fjord: '#6C848C',
  wheat: '#F5DEB3',

  // Camouflage/pattern names -- these are textures, not flat colors, so
  // per the design's accepted tradeoff (see spec, "Deferred / explicitly
  // out of scope") each pattern family gets one representative flat
  // approximation rather than being left as an empty placeholder.
  camouflage: '#78866B', // alias of the existing bare "camo" entry
  realtree: '#6B5D44',
  'real tree': '#6B5D44', // same pattern family, space-separated vendor spelling
  'mossy oak': '#5C5240',
  kryptek: '#5B5A4E',
  multicam: '#7A7863',
  'stars stripes': '#22346B',

  // 2026-09-30 expansion, part 2 -- long-tail single/simple-phrase colors
  // from the same coverage audit, past the initial high-frequency pass.
  almond: '#EADDCA',
  aloe: '#9DC183',
  amethyst: '#9966CC',
  apricot: '#FBCEB1',
  'arctic mist': '#DCE9EC',
  banana: '#FFE135',
  bay: '#6E2C1E',
  beige: '#F5F5DC',
  blackbamboo: '#000000', // run-on two-tone name -- resolves to its first color
  blackberry: '#4D0135',
  blanc: '#FAFAFA',
  blaze: '#FF6700',
  blizzard: '#F0F8FF',
  blossom: '#FFC3DE',
  blueberry: '#4D4DBA',
  blueprint: '#2C5F8A',
  bluestone: '#4A6670',
  blush: '#F4C2C2',
  bordeaux: '#5C0120',
  boulder: '#6D6A75',
  brick: '#A62E28',
  bronze: '#CD7F32',
  'bubble gum': '#FFC1CC',
  buttermilk: '#FFF1B6',
  butterscotch: '#E3963E',
  cactus: '#587246',
  cantaloupe: '#FFA62B',
  canyon: '#965A3F',
  caribbean: '#00CCCC',
  carolina: '#4B9CD3',
  'carolina blue': '#4B9CD3',
  cayenne: '#D2451E',
  celadon: '#ACE1AF',
  'celery juice': '#C9CF8A',
  cement: '#8C8C84',
  chai: '#C8A27A',
  chambray: '#8CA9C4',
  charity: '#F78FA7',
  'charity pink': '#F78FA7',
  cherry: '#D2042D',
  'cherry blossom': '#FFB7C5',
  cherrywood: '#651A14',
  chili: '#C21807',
  citrine: '#E4D00A',
  citron: '#9FA91F',
  coconut: '#F0EAD6',
  concrete: '#97998C',
  'cooked carrot': '#ED9121',
  cornsilk: '#FFF8DC',
  creamblack: '#FFFDD0', // run-on two-tone name -- resolves to its first color
  creme: '#FFFDD0',
  crimson: '#DC143C',
  crunchberry: '#E75480',
  cucumber: '#83A67F',
  cumin: '#9A5B33',
  cyan: '#00FFFF',
  daisy: '#FFEC5C',
  dandelion: '#F0E130',
  'dark cherry': '#5C0E14',
  dijon: '#C89F3C',
  dune: '#C2B183',
  dusk: '#4B4C6D',
  dust: '#B0A695',
  eggplant: '#614051',
  eggshell: '#EFE1C6',
  elderberry: '#5B2C6F',
  espresso: '#3C2414',
  evergreen: '#05472A',
  fern: '#4F7942',
  fiesta: '#FF5A36',
  flamingo: '#FC8EAC',
  forrest: '#228B22', // common vendor misspelling of "forest"
  frost: '#E8F1F2',
  'fruit punch': '#C21E56',
  gardenia: '#FFFAF0',
  garnet: '#733635',
  glacier: '#A9D6E5',
  'golden pecan': '#B4793C',
  'golden spice': '#C68E17',
  greige: '#B7AFA3',
  greybamboo: '#808080', // run-on two-tone name -- resolves to its first color
  greyblack: '#808080',
  greystone: '#93938B',
  griege: '#B7AFA3',
  'gun metal': '#2A3439',
  heliconia: '#E80C7A',
  hemp: '#9B7653',
  huckleberry: '#5C3566',
  hydrangea: '#B3A6D9',
  hydro: '#4FA8C9',
  iris: '#5A4FCF',
  'iron gate': '#43464B',
  'island reef': '#3FA796',
  jadeite: '#00A877',
  lakeshore: '#6E8B95',
  lapis: '#26619C',
  latte: '#B08968',
  lead: '#4A4A4A',
  leaf: '#71BC78',
  lemonade: '#FDE9A9',
  lemongrass: '#C9DC5A',
  limestone: '#C6C0A9',
  macchiato: '#A67B5B',
  marina: '#1B4F72',
  marine: '#003366',
  maroonblack: '#800000', // run-on two-tone name -- resolves to its first color
  mauvelous: '#EF98AA',
  melon: '#FDBCB4',
  mineral: '#7A8B99',
  mist: '#C4D7D9',
  mulberry: '#770737',
  nickel: '#727472',
  oxblood: '#4A0404',
  oyster: '#DAD6CB',
  paprika: '#A5450D',
  peach: '#FFE5B4',
  peachy: '#FFCBA4',
  peacock: '#005F69',
  pepper: '#3B3B3B',
  periwinkle: '#CCCCFF',
  petrol: '#0C3C44',
  pewter: '#899499',
  pine: '#2E4C39',
  plumrose: '#C08CA1',
  popcorn: '#F3E5AB',
  poppy: '#E35335',
  putty: '#C6C0A5',
  rainforest: '#1C7C54',
  rhino: '#8B8C89',
  'roan rouge': '#A45A52',
  rosewood: '#65000B',
  ruby: '#9B111E',
  russet: '#80461B',
  rust: '#B7410E',
  salmon: '#FA8072',
  saltwater: '#4C9F9F',
  sangria: '#6E0D25',
  'sea glass': '#A9C6C2',
  shiitake: '#8A6E52',
  shiraz: '#5B0A24',
  sky: '#87CEEB',
  snow: '#FFFAFA',
  soapstone: '#D6D2C4',
  spearmint: '#9FE2BF',
  spruce: '#0A5C36',
  stargazer: '#C24C88',
  straw: '#E4D96F',
  suede: '#C8A26A',
  tangerine: '#F28500',
  tanzanite: '#4863A0',
  terracotta: '#E2725B',
  thyme: '#588157',
  toast: '#BC8F5D',
  topaz: '#FFC87C',
  tortoise: '#7C5A3A',
  tortoisewhite: '#7C5A3A', // run-on two-tone name -- resolves to its first color
  trenchcoat: '#8A7357',
  umber: '#635147',
  vanilla: '#F3E5AB',
  'varsity maize': '#FFC72C',
  wasabe: '#7A9B76',
  'warm quartz': '#D8B9A8',
  whiskey: '#C08552',
  wine: '#74334F', // 2026-10-28: was #722F37; aligned with the vendor table's "Plumberry/Wine" so that slash name stays one solid color
  wisteria: '#C9A0DC',
  wood: '#966F33',
  yam: '#C2703D',
  yellowwhite: '#FFFF00', // run-on two-tone name -- resolves to its second color
  zinnia: '#DB2955',
  whiteblack: '#FFFFFF', // run-on two-tone name -- resolves to its first color
  'athletic goldwhite': '#D4AF37', // run-on two-tone name -- resolves to its first color
  wineberry: '#722F37', // run-on two-tone name -- resolves to its first color

  // Vendor-specific shades (SanMar / Carhartt / Mercer+Mettle), added 2026-10-20.
  // Phrase keys on purpose: a bare word like "orange" or "blue" already matched
  // these names with a generic dot, which is the wrong shade (safety orange is
  // far redder than #FFA500). Values below were sampled from the garment's own
  // product photo in our stores' catalogs, except the two marked "estimated".
  'safety orange': '#FB6E12',
  'safety yellow': '#DCE334', // hi-vis yellow-green
  'duck brown': '#92633E',
  'carhartt brown': '#8F5F38',
  'royal glass blue': '#0C4085', // one product photo only
  'fresh water blue': '#87BCDE', // one product photo only
  'bright orange': '#EC5D29',
  'dark sienna': '#7F4434',
  'river blue': '#4A7DAA', // estimated -- no product photo in any catalog yet
  'dark cobalt blue': '#1B3F8B', // estimated -- no product photo in any catalog yet

  // Scrub-brand and Carhartt shades, added 2026-10-27/28. Keys are the normalized names (the
  // matcher lowercases and turns punctuation into spaces, so "St. Barts" -> 'st barts').
  // "table" = the hex given in the vendor color table (2026-10-28); "estimated" = no
  // table value and no product photo yet, guessed from the brand notes.
  ceil: '#A5D8E8', // table
  ciel: '#A5D8E8', // table (Cherokee / Dickies spelling of Ceil)
  'true ceil': '#91BECC', // estimated: koi's slightly deeper Ceil
  galaxy: '#344E83', // table (also matches "Galaxy Blue")
  bahama: '#42B9C7', // table (Barco family teal blue)
  moonstruck: '#858B9A', // table
  rainwater: '#9DB6C6', // estimated (Healing Hands)
  'trade winds': '#76A9A8', // table
  nectar: '#F0A860', // estimated (Healing Hands)
  cloud: '#C8CDD3', // estimated (Med Couture)
  wasabi: '#A3B94A', // estimated (Med Couture)
  'solar flare': '#F4A11D', // estimated (Med Couture)
  'back to the fuchsia': '#C9267D', // estimated (Med Couture's fuchsia)
  'electric fuchsia': '#E50087', // table (Carhartt)
  'electric fuschia': '#E50087', // table; misspelling seen in vendor data
  'douglas fir': '#254D3D', // table (Carhartt)
  sable: '#55463E', // table (Carhartt)
  cognac: '#9A5B34', // estimated (koi)
  persimmon: '#EA5B2B', // estimated (Skechers)
  'st barts': '#2BA3C7', // estimated (Parkley)
  submarine: '#3A5668', // estimated (Adar)
  sherbet: '#FFB38A', // table (Adar)
  cinnamon: '#9B5A2E', // estimated (Adar)
  apple: '#78B33E', // estimated (Adar)
  plumberry: '#74334F', // table "Plumberry/Wine"; same as wine so the slash name is one color

  // More names from the 2026-10-28 vendor color table (hex as given). Several are scrub
  // PRINT names, not plain colors; the hex is the print's dominant color.
  'rolling thunder': '#777B85',
  'paradise cove': '#44C5BD',
  iron: '#555B62',
  'papaya juice': '#FF986A',
  'ice cold': '#C4EAF2',
  'flamazing skaters': '#F28BA8',
  'wellness icons': '#86B8B0',
  'pickleball toile': '#B1C998',
  'doggy doodle': '#B9A2D3',
  'silly goose': '#F4DDA5',
  'pretty hearts': '#F4A6BC',
  dogisms: '#A7B6D4',
  'active butterfly': '#C5A5DE',
  'butterfly confetti': '#E7B5D9',
  'taste buds': '#F5B66E',
  'cutest apple': '#D95B65',
  'tricks n treats': '#D97932',
  'stitch too cool': '#5C99C8',
  'iconic mickey': '#D93A43',
  'tale of a mermaid': '#72C5C6',
  'full of spirit': '#A88AC7',
  'feeling flirty': '#F09DBB',
  'minnie spotlight': '#E36B9C',
  'my big heart': '#E86A78',
  'ginger tweet': '#E5B36D',
  'snoopy on ice': '#B8DCEB',
  terrain: '#8B7964',
  moonstone: '#A8AEBB',
  'ginger glow': '#D88D53',
  brownstone: '#806A5E',
};
